import Vue from 'vue'
import Vuex from 'vuex'
import auth from '#/store/auth'
import address from '#/store/address'
import description from '#/store/description'
import cart from './modules/cart'
import shop from './modules/shop'
import distribution from '#/store/distribution'
import keepAlive from '#/store/keepAlive'
import order from '#/store/order'
import wxMiniApp from '#/store/wxMiniApp'

Vue.use(Vuex)

const storeInstance = new Vuex.Store({
    modules: {
        auth,
        address,
        cart,
        shop,
        description,
        distribution,
        keepAlive,
        order,
        wxMiniApp,
    },
});

export default storeInstance;
